import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import UserConsultationTab from "../Components/UserConsultationTab";
import { chat, consultantmage, file } from "../Constant/Index";

const UserBillingDetail = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="row">
									<div class="col-lg-12">
										<div className="main-headind d-flex align-items-center extra-bg-14 radius-20 dark-color gap-4 p-4 mb-3">
											<div class="edit-btn back">
												<Link to="/">
													<div class="nav-anchor">
														<i class="fa-solid fa-arrow-left"></i>
													</div>
												</Link>
											</div>
											<div class="content-qty   ">
												<div className="d-flex gap-3 align-items-center">
													<img
														src={consultantmage}
														className="img-fluid"
														alt=""
													/>
													<div>
														<h4 class="main-heading-font level-6 ">
															Dr. David Patel
														</h4>
														<h5 class="primary-medium-font level-8 extra-color-15">
															Physician
														</h5>
														<h4 class="primary-medium-font level-7 ">
															<span className="icon-point">
																<i class="fa-solid fa-location-dot"></i>
															</span>{" "}
															Golden Cardiology Center
														</h4>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
											<form>
												<h4 class="main-heading-font level-6 mb-3">
													Billing Details
												</h4>
												<div className="row">
													<div className="form-group col-lg-6">
														<input
															type="text"
															className="form-control"
															id="firstName"
															placeholder=" First Name"
														/>
													</div>
													<div className="form-group col-lg-6">
														<input
															type="text"
															className="form-control"
															id="lastName"
															placeholder=" Last Name"
														/>
													</div>
												</div>
												<div className="form-group col-lg-12">
													<input
														type="email"
														className="form-control"
														id="email"
														placeholder="Enter email"
													/>
												</div>
												<div className="form-group col-lg-12">
													<input
														type="tel"
														className="form-control"
														id="phone"
														placeholder=" phone number"
													/>
												</div>
												<h4 class="main-heading-font level-6 mb-3 mt-3">
													Address
												</h4>
												<div className="row">
													<div className="form-group col-lg-12">
														<input
															type="text"
															className="form-control"
															id="phone"
															placeholder=" Address"
														/>
													</div>
													<div className="form-group col-lg-3">
														<input
															type="text"
															className="form-control"
															id="phone"
															placeholder=" City"
														/>
													</div>
													<div className="form-group col-lg-3">
														<input
															type="text"
															className="form-control"
															id="phone"
															placeholder="State"
														/>
													</div>
													<div className="form-group col-lg-3">
														<input
															type="text"
															className="form-control"
															id="phone"
															placeholder="Country"
														/>
													</div>
													<div className="form-group col-lg-3">
														<input
															type="number"
															className="form-control"
															id="phone"
															placeholder=" Zip Code "
														/>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty d-flex align-items-center justify-content-between extra-bg-14 radius-20 p-4 dark-color">
											<h4>Payment Method</h4>
											<h4>Cash on Delivery</h4>
										</div>
									</div>
								</div>
								<div class="row mt-2">
									<div className="col-lg-12">
										<div className="d-flex align-items-center gap-3">
											<Link
												class="btn wrapper-btn-main w-100 log-in mt-2 level-7 primary-regular-font text-decoration-none"
												to="/user-prescription-address"
											>
												<span class="bg-wrapper w-100">Place Order</span>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserBillingDetail;
